import React from 'react';

export function InputText({type = 'text', value, placeholder = null, setValue, onReturn = null}) {

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onReturn) {
            onReturn();
        }
    };

    return (
        <input type={type} className='block h-14 border-[1px] bg-transparent border-slate-200 rounded-2xl text-[1.1em] text-slate-950 px-4 outline-none ring-1 ring-inset ring-transparent hover:border-slate-400 focus:border-black focus:ring-black transition-all duration-200 dark:text-white dark:border-slate-700 dark:hover:border-slate-500 dark:focus:border-white dark:focus:ring-white' value={value} onChange={handleChange} onKeyDown={handleKeyDown} placeholder={placeholder}  />
    );
}